import extend from 'lodash/extend';
import each from 'lodash/each';
import { resultsConfig } from '@Constants/Results';

function _updateReactionsWithExtraInfo(results, data) {
  each(results, (result) => {
    const { products, reactants } = result;
    extend(result, {
      ...(products && {
        products: products.map((product) => ({
          ...product,
          ...data.payload[product.details.id],
        })),
      }),
      ...(reactants && {
        reactants: reactants.map((reactant) => ({
          ...reactant,
          ...data.payload[reactant.details.id],
        })),
      }),
    });
  });
}

function _updateTargetsWithExtraInfo(results, data) {
  each(results, (result) => {
    extend(result, {
      mostActiveSubstanceDetails: data.payload[result.targetId],
    });
  });
}

function _updateSubstancesWithExtraInfo(results, data) {
  each(results, (result) => {
    const { details } = result;
    extend(result, {
      ...(details &&
        details.mixtureItems && {
          details: {
            ...details,
            mixtureItems: details.mixtureItems.map((mixtureItem) => ({
              ...mixtureItem,
              ...data.payload[mixtureItem.id],
            })),
          },
        }),
    });
  });
}

function _updateExtraInfoHandlers(context) {
  switch (context) {
    case resultsConfig.CONTEXT.reactions:
      return _updateReactionsWithExtraInfo;
    case resultsConfig.CONTEXT.targets:
      return _updateTargetsWithExtraInfo;
    case resultsConfig.CONTEXT.substances:
      return _updateSubstancesWithExtraInfo;
    default: {
      Logger.warn('Invalid context: ', context);
      return () => undefined;
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export function updateWithExtraInfo(context, items, customInfo) {
  if (!customInfo || !customInfo.payload || !customInfo.payload.size) {
    return;
  }
  _updateExtraInfoHandlers(context)(items, customInfo);
}
